<template>
  <div data-test-id="page-header-info">
    <tippy
      tag="button"
      content-tag="div"
      content-class="content-wrapper"
      :interactive="true"
      placement="right-start"
      max-width="250px"
    >
      <template #default>
        <cl-icon-tabler-info-circle
          :width="18"
          :height="18"
          class="tw-text-dorian-gray-200"
        />
      </template>
      <template #content>
        <div>{{ text }}</div>
        <a
          v-if="docsLink"
          :href="docsLink"
          target="_blank"
          class="tw-inline-block tw-underline tw-text-info-500"
        >
          <span class="tw-flex tw-gap-1 tw-items-center">
            {{ $t("text-block-learn-more") }}
            <cl-icon-tabler-external-link width="16" height="16" />
          </span>
        </a>
      </template>
    </tippy>
  </div>
</template>

<script setup lang="ts">
type Props = {
  text: string;
  docsLink: string;
};

defineProps<Props>();
</script>
